import React from 'react';

export const chaintoolsPagesConfig = [
  {
    auth: ['user'],
    routes: [
      {
        path: '/chaintools/pricing',
        component: React.lazy(() => import('./Pages/ChainToolsPage')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: '/chaintools/newsletter',
        component: React.lazy(() => import('./Pages/ChainToolsNewsletterPage')),
      }
    ]
  }
];